"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunkDHMQIKTCcjs = require('./chunk-DHMQIKTC.cjs');


var _chunkFXL7SAQJcjs = require('./chunk-FXL7SAQJ.cjs');

// src/contracts/dex/v2_1/router/RouterV2_1.ts
var RouterV2_1 = (_class = class extends _chunkFXL7SAQJcjs.BaseRouterV2_1 {
  static __initStatic() {this.CPI = _chunkDHMQIKTCcjs.CPIRouterV2_1}
}, _class.__initStatic(), _class);



exports.RouterV2_1 = RouterV2_1;
//# sourceMappingURL=chunk-W7K7GB4D.cjs.map